export const iconKontrak2 = "https://img.icons8.com/?size=100&id=48354&format=png&color=1677ff";
export const iconKontrak = "https://img.icons8.com/?size=100&id=y3PxkrQHqcEB&format=png&color=1677ff";
export const iconPerusahaan = "https://img.icons8.com/?size=100&id=lrrWa22VGVi6&format=png&color=000000";
export const iconNilaiKontrak = "https://img.icons8.com/?size=100&id=KyaxbI6JuwGT&format=png&color=000000";
export const iconTanggalKontrak = "https://img.icons8.com/?size=100&id=PTVr218c3sJO&format=png&color=000000";

